export enum ContractStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  DISAPPROVE = "DISAPPROVE",
  CONFIRM = "CONFIRM",
  APPROVE = "APPROVE",
  UNDERREVIEW = "UNDERREVIEW",
}
